import CollectionAmenity from "./amenities/collection";
import Community from "./community";

export default class Collection {
    id = null;
    slug = null;
    status = null;
    community_rid = null;
    division_id = null;
    meta = {
        interactives: [],
        videos: [],
        info: {
            name: null,
            tagline: null,
            description: null,
            status: null,
            website: null,
            interest_rate: null
        },
        sales_office: {
            address: {
                street1: null,
                street2: null,
                city: null,
                state: null,
                zip: null,
                in_collection: false
            },
            geo: {
                lat: 0,
                lng: 0
            },
            phone: null,
            hours: [
                {start: null, end: null, appointment: false},
                {start: null, end: null, appointment: false},
                {start: null, end: null, appointment: false},
                {start: null, end: null, appointment: false},
                {start: null, end: null, appointment: false},
                {start: null, end: null, appointment: false},
                {start: null, end: null, appointment: false}
            ],
            email: 'hello@oakwoodhomesco.com',
        }
    };
    image = null;
    kova = {};
    created_at = null;
    updated_at = null;
    deleted_at = null;
    community = {};

    constructor(data) {
        this.id = data?.id ?? this.id;
        this.slug = data?.slug ?? this.slug;
        this.status = data?.status ?? this.status;
        this.community_rid = data?.community_rid ?? this.community_rid;
        this.division_id = data?.division_id ?? this.division_id;
        this.meta = {
            interactives: data?.meta?.interactives ?? this.meta.interactives,
            videos: data?.meta?.videos ?? this.meta.videos,
            info: {
                name: data?.meta?.info?.name ?? data?.kova?.Name ?? this.meta.info.name,
                tagline: data?.meta?.info?.tagline ?? this.meta.info.tagline,
                description: data?.meta?.info?.description ?? this.meta.info.description,
                status: data?.meta?.info?.status ?? this.meta.info.status,
                website: data?.meta?.info?.website ?? this.meta.info.website,
                interest_rate: data?.meta?.info?.interest_rate ?? this.meta.info.interest_rate,
            },
            sales_office: {
                
                address: {
                    street1: data?.meta?.sales_office?.address?.street1 ?? this.meta.sales_office.address.street1,
                    street2: data?.meta?.sales_office?.address?.street2 ?? this.meta.sales_office.address.street2,
                    city: data?.meta?.sales_office?.address?.city ?? this.meta.sales_office.address.city,
                    state: data?.meta?.sales_office?.address?.state ?? this.meta.sales_office.address.state,
                    zip: data?.meta?.sales_office?.address?.zip ?? this.meta.sales_office.address.zip,
                    in_community: data?.meta?.sales_office?.address?.in_community ?? this.meta.sales_office.address.in_community,
                    in_collection: data?.meta?.sales_office?.address?.in_collection ?? this.meta.sales_office.address.in_collection
                },
                geo: {
                    lat: data?.meta?.sales_office?.geo?.lat ?? this.meta.sales_office.geo.lat,
                    lng: data?.meta?.sales_office?.geo?.lng ?? this.meta.sales_office.geo.lng

                },
                phone: data?.meta?.sales_office?.phone ?? this.meta.sales_office.phone,
                hours: [
                    { 
                        start: data?.meta?.sales_office?.hours[0]?.start ?? this.meta.sales_office.hours[0].start, 
                        end: data?.meta?.sales_office?.hours[0]?.end ?? this.meta.sales_office.hours[0].end, 
                        appointment: data?.meta?.sales_office?.hours[0]?.appointment ?? this.meta.sales_office.hours[0].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[1]?.start ?? this.meta.sales_office.hours[1].start, 
                        end: data?.meta?.sales_office?.hours[1]?.end ?? this.meta.sales_office.hours[1].end, 
                        appointment: data?.meta?.sales_office?.hours[1]?.appointment ?? this.meta.sales_office.hours[1].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[2]?.start ?? this.meta.sales_office.hours[2].start, 
                        end: data?.meta?.sales_office?.hours[2]?.end ?? this.meta.sales_office.hours[2].end, 
                        appointment: data?.meta?.sales_office?.hours[2]?.appointment ?? this.meta.sales_office.hours[2].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[3]?.start ?? this.meta.sales_office.hours[3].start, 
                        end: data?.meta?.sales_office?.hours[3]?.end ?? this.meta.sales_office.hours[3].end, 
                        appointment: data?.meta?.sales_office?.hours[3]?.appointment ?? this.meta.sales_office.hours[3].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[4]?.start ?? this.meta.sales_office.hours[4].start, 
                        end: data?.meta?.sales_office?.hours[4]?.end ?? this.meta.sales_office.hours[4].end, 
                        appointment: data?.meta?.sales_office?.hours[4]?.appointment ?? this.meta.sales_office.hours[4].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[5]?.start ?? this.meta.sales_office.hours[5].start, 
                        end: data?.meta?.sales_office?.hours[5]?.end ?? this.meta.sales_office.hours[5].end, 
                        appointment: data?.meta?.sales_office?.hours[5]?.appointment ?? this.meta.sales_office.hours[5].appointment 
                    },
                    { 
                        start: data?.meta?.sales_office?.hours[6]?.start ?? this.meta.sales_office.hours[6].start, 
                        end: data?.meta?.sales_office?.hours[6]?.end ?? this.meta.sales_office.hours[6].end, 
                        appointment: data?.meta?.sales_office?.hours[6]?.appointment ?? this.meta.sales_office.hours[6].appointment 
                    },
                ],
                email: data?.meta?.sales_office?.email ?? this.meta.sales_office.email,
            },
            amenities: (data?.meta?.amenities ?? []).map(amenity => new CollectionAmenity(amenity)) ?? this.meta.amenities
        };
        this.image = data?.image ?? this.image;
        this.kova = data?.kova ?? this.kova;
        this.created_at = data?.created_at ?? this.created_at;
        this.updated_at = data?.updated_at ?? this.updated_at;
        this.deleted_at = data?.deleted_at ?? this.deleted_at;
        this.community = new Community(data?.community ?? this.community)

        return this;
    }
}